export default class WindowHelper {
  static getWindow(target = 'self') {
    try {
      switch (target) {
        case 'self':
          return window
        case 'parent':
          if (window.parent && window.parent !== window) {
            return window.parent
          }
          throw new Error('Parent window is not accessible.')
        case 'top':
          if (window.top && window.top !== window) {
            return window.top
          }
          throw new Error('Top window is not accessible.')
        default:
          throw new Error(`Invalid target ${target}`)
      }
    } catch (error) {
      console.error(`Error accessing window (${target}):`, error)
      return null
    }
  }
}
